<template>
    <div class="coupons-list-warp">
        <div class="coupons-list">
            <div :class="['coupons-list-item', item.isChecked ? 'active' : '']" v-for="(item, index) in couponsList" :key="item.id">
                <div class="coupons-list-item-infoBox">
                    <div class="coupons-list-item-infoBox-left">
                        <label>{{ item.name }}</label>
                        <span v-if="item.end_time">有效期<br/>{{ fomatterDate(item.start_time) }}至{{ fomatterDate(item.end_time) }}</span>
                    </div>
                    <div class="coupons-list-item-infoBox-right">
                        <label>可抵扣{{ item.discount_amount / 100 }}元</label>
                        <span>满{{ item.target_amount / 100 }}减{{ item.discount_amount / 100 }}元券</span>
                    </div>
                </div>
                <div class="coupons-list-item-ruleBox">
                    <span></span>
                    <div :class="[item.canUse ? '' : 'disabled']" @click="goBack(index)">立即使用</div>
                </div>
            </div>
        </div>
        <Empty v-if="!couponsList.length" description="暂无可用优惠券" />
    </div>
</template>
<script>
import { Empty } from 'vant';
export default {
    components: { Empty },
    data() {
        return {
            couponsList: []
        }
    },
    activated() {
        this.couponsList = window.localStorage.getItem('couponsList') ? JSON.parse(window.localStorage.getItem('couponsList')) : []
        console.log('couponsList=====>', this.couponsList)
    },
    methods: {
        goBack(index) {
            this.$EventBus.$emit('couponsCheck', {ckeckId: index})
            this.$router.go(-1)
        },
        fomatterDate(e){
            if (e) {
                return e.split('T')[0]
            } else {
                return e
            }
        }
    },
    beforeDestroy() {
        window.localStorage.setItem('couponsList', '')
    }
}
</script>
<style lang="scss">
.coupons-list-warp {
    padding: 16px;
    .coupons-list {
        .coupons-list-item {
            padding: 16px;
            background: #fff;
            border-radius: 8px;
            margin-bottom: 16px;
            box-sizing: border-box;
            &.active {
                border: 1px solid #08aef9;
            }
            .coupons-list-item-infoBox {
                border-bottom: 1px dashed #999;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 16px;
                .coupons-list-item-infoBox-left {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    label {
                        font-size: 16px;
                        font-weight: 500;
                        color: #000;
                        margin-bottom: 10px;
                    }
                    span {
                        font-size: 12px;
                        font-weight: 400;
                        color: #999;
                    }
                }
                .coupons-list-item-infoBox-right {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    align-items: flex-end;
                    label {
                        font-size: 12px;
                        font-weight: 400;
                        color: #f65a5a;
                        margin-bottom: 6px;
                    }
                    span {
                        font-size: 20px;
                        font-weight: 600;
                        color: #f65a5a;
                    }
                }
            }
            .coupons-list-item-ruleBox {
                display: flex;
                justify-content: space-between;
                padding-top: 10px;
                span {
                    font-weight: 400;
                    font-size: 12px;
                    color: #999;
                    flex-grow: 1;
                }
                div {
                    width: 90px;
                    border: 1px solid #08aef9;
                    color: #08aef9;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 15px;
                    &.disabled {
                        border-color: #999;
                        color: #999;
                        pointer-events: none;
                    }
                }
            }
        }
    }
}
</style>
